import { FiX } from "react-icons/fi";

export default function ImagePreviewModal({ onClose, image }) {
  return (
    <div className="w-full h-full flex items-center justify-center relative">
      <div className="flex w-full max-w-[1280px] aspect-video justify-center">
        <img
          src={image.url || image.thumbnail_url}
          alt={image.name}
          decoding="async"
          width={1280}
          height={720}
          className="object-contain relative w-auto h-full"
        />
      </div>
      <button
        type="button"
        onClick={() => onClose(null)}
        className="absolute top-4 right-4 z-10 p-2 rounded-md text-secondary-foreground hover:bg-secondary/60 cursor-pointer"
        title="Close">
        <FiX className="w-7 h-7" />
      </button>
    </div>
  );
}
